<style scoped lang="scss">
  .page-employee-maintenanceStatistics {
    /deep/ .toolbars {
      .buttons {
        .mobile-group-button {
          padding-left: 9px;
          padding-right: 9px;
        }
      }
    }
  }
</style>

<template>
  <div class="page-employee-maintenanceStatistics">
    <el-alert class="mrgb10" type="warning" :closable="false">
        <span slot="title">
            当前为员工管理的维修统计，默认统计员工<span class="col_danger fwb">【所有工作过的服务区】</span>的维修数据。
        </span>
    </el-alert>
    <div class="toolbars mrgb5">
        <div class="buttons mrgb5">
            <div class="fl">
              <el-button-group class="mrgr5 mrgb5">
                  <el-button :class="$root.isPc ? '' : 'mobile-group-button'" type="primary" v-for="(tab, index) in tabs" :plain="tabIndex !== index"
                      :key="'employee_tab_' + index" size="medium" @click="tabClick(index)">{{ tab }}</el-button>
              </el-button-group>
              <el-date-picker class="c-datetime-range mrgr5 mrgb5" v-model="selectedTime" type="datetimerange" size="medium" v-show="isShowSelectTime"
                    :picker-options="pickerOptions" :default-time="['00:00:00', '23:59:59']" @change="_search"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    align="right">
                </el-date-picker>
            </div>
            <div class="fr">
                <span class="mrgr5 mrgb5">
                    <el-checkbox v-model="listQuery.isFilterArea" label="仅看当前服务区" border size="medium"
                        @change="serviceAreaChange"></el-checkbox>
                </span>
                <el-input class="c-el-input mrgr5 mrgb5" placeholder="员工的姓名/手机号" clearable v-model="listQuery.telOrName"
                    size="medium"></el-input>
                <el-button type="primary" size="medium" @click="_search()"><i class="fa fa-search"></i> 查询</el-button>
                <el-tooltip effect="dark" content="导出员工维修统计数据" placement="top-start">
                  <el-button class="mrgb5" type="success" size="medium" @click="openExportEmployeesExcelLocal()"><i class="fa fa-sign-out"></i> 导出员工维修统计</el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="按员工分别导出对应的维修数据" placement="top-start">
                  <el-button class="mrgb5" type="warning" size="medium" @click="openExportExcels()"><i class="fa fa-sign-out"></i> 一键导出</el-button>
                </el-tooltip>
            </div>
            <div class="clearb"></div>
        </div>
    </div>
    <el-table :data="tableData" style="width: 100%" border size="medium">
      <el-table-column label="姓名" prop="name"></el-table-column>
      <el-table-column label="联系电话" prop="tel"></el-table-column>
      <el-table-column label="工作过的服务区" prop="workAreas" width="250">
        <template slot-scope="scope">
          <el-tag v-for="(item, index) in scope.row.workAreas" class="mrgb5 mrgr5" :key="index" type="info" effect="plain" size="small">
            【<span class="fwb">{{ item.platform || "" }}</span>】{{ item.name || "" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="维修总量" prop="totalTasks">
        <template slot-scope="scope">
            <el-tag type="primary" size="small" @click="navTo(scope.row)">{{ scope.row.totalTasks }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="有效维修量/占比" prop="effectiveTasks">
        <template slot-scope="scope">
            <el-tag type="success" size="small" @click="navTo(scope.row, 1)">
              {{ scope.row.effectiveTasks }}
            </el-tag>
            <el-tag class="mrgl5" type="info" effect="plain" size="small" @click="navTo(scope.row, 1)">
              {{ scope.row.effective_rate }}%
            </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="无效维修量/占比" prop="invalidTasks">
        <template slot-scope="scope">
            <el-tag type="danger" size="small" @click="navTo(scope.row, 0)">
              {{ scope.row.invalidTasks }}
            </el-tag>
            <el-tag class="mrgl5" type="info" effect="plain" size="small" @click="navTo(scope.row, 0)">
              {{ scope.row.invalid_rate }}%
            </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="160" fixed="right">
        <template slot-scope="scope">
            <el-button type="primary" plain size="mini" @click="navTo(scope.row)">详情</el-button>
            <el-tooltip effect="dark" :content="scope.row.name + '的维修数据'" placement="left">
              <el-button type="warning" plain size="mini" @click="openExportExcel(scope.row)">导出</el-button>
            </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <!--导出excel-->
    <export-to-excel :ref="refExportToExcel"></export-to-excel>
    <!-- 维修详情弹窗 -->
    <el-dialog :title="maintenanceDataTitle" :fullscreen="true"
      :visible.sync="maintenanceDataVisible" :before-close="_close" :close-on-click-modal="false">
      <maintenance-data :ref="refMaintenanceData"></maintenance-data>
    </el-dialog>
  </div>
</template>

<script>
  import * as funEmployees from '@/api/employees'
  import moment from "moment"
  import ExportToExcel from "@/components/Excels/JsonToExcel"
  import { AnalysisMaintenanceStatistics, AnalysisMaintenanceTask } from "@/mixins/commonPageExport"
  import MaintenanceData from "./maintenanceData"
  export default {
    name: "pageEmployeeMaintenanceStatistics",
    components: { ExportToExcel, MaintenanceData },
    data() {
      let that = this
      return {
        refExportToExcel: "refEmployeeToMaintenanceStatistics",
        refMaintenanceData: "refEmployeeToMaintenanceStatistics",
        tableData: [],
        defaultQueryParams: {
          platform: "",
          area: "",
          telOrName: "",
          keywords: "",
          beginDate: "",
          endDate: "",
          flag: null,
          isAudited: null,
          auditFlag: null,
          isFilterArea: false // 添加筛选服务区的标志
        },
        listQuery: {},
        selectedTime: [moment().startOf("month").format("YYYY-MM-DD 00:00:00"), moment().format("YYYY-MM-DD 23:59:59")],
        pickerOptions: {
            shortcuts: [
                {
                    text: "昨天",
                    onClick: (picker) => {
                        let timeArr = that.setPickerTime(picker, 1, "days")
                        that.setQueryTime(timeArr)
                    }
                },
                {
                    text: "近一周",
                    onClick: (picker) => {
                        let timeArr = that.setPickerTime(picker, 1, "weeks")
                        that.setQueryTime(timeArr)
                    }
                },
                {
                    text: "近一月",
                    onClick(picker) {
                        let timeArr = that.setPickerTime(picker, 1, "months")
                        that.setQueryTime(timeArr)
                    }
                },
                {
                    text: "近三月",
                    onClick(picker) {
                        let timeArr = that.setPickerTime(picker, 3, "months")
                        that.setQueryTime(timeArr)
                    }
                },
                {
                    text: "近半年",
                    onClick(picker) {
                        let timeArr = that.setPickerTime(picker, 6, "months")
                        that.setQueryTime(timeArr)
                    }
                },
                {
                    text: "近一年",
                    onClick(picker) {
                        let timeArr = that.setPickerTime(picker, 1, "years")
                        that.setQueryTime(timeArr)
                    }
                }
            ]
        },
        tabIndex: 0,
        tabs: ["昨日", "本月", "上月", "自定义"],
        isShowSelectTime: false,
        maintenanceDataVisible: false,
        maintenanceDataTitle: ""
      }
    },
    watch: {
        "$store.getters.serviceArea"(v) {
            this.mxIsSameActiveTabWithRoute(() => {
                this.serviceAreaChange(this.listQuery.isFilterArea)
            })
        }
    },
    mounted() {
      this.open()
    },
    methods: {
      open() {
        // 重置查询参数
        this.listQuery = { ...this.defaultQueryParams }
        this.tabClick(0)
      },
      // 重写本页的时间范围的快捷筛选，设置时间
      setPickerTime(picker, spaceTime, dateStr, isStartOf) {
          let timeArr = []
          let startTime = null
          let endTime = moment().subtract(1, "d").format("YYYY-MM-DD 23:59:59")
          startTime = moment().subtract(spaceTime, dateStr).format("YYYY-MM-DD 00:00:00")
          startTime = moment(startTime).format("YYYY-MM-DD 00:00:00")
          timeArr = [startTime, endTime]
          if (picker) {
              picker.$emit('pick', timeArr);
          }
          return timeArr
      },
      setQueryTime(timeArr) {
          this.listQuery.beginDate = timeArr[0] || ""
          this.listQuery.endDate = timeArr[1] || ""
      },
      setSelectedTime() {
          let psTime = ""
          let peTime = ""
          if (this.selectedTime && this.selectedTime[0] && moment(this.selectedTime[0]).isValid()) {
              psTime = moment(this.selectedTime[0]).format("YYYY-MM-DD HH:mm:ss")
          }
          if (this.selectedTime && this.selectedTime[1] && moment(this.selectedTime[1]).isValid()) {
              peTime = moment(this.selectedTime[1]).format("YYYY-MM-DD HH:mm:ss")
          }
          this.listQuery.beginDate = psTime
          this.listQuery.endDate = peTime
          this.selectedTime = [this.listQuery.beginDate, this.listQuery.endDate]
      },
      async getListData() {
        this.setSelectedTime()
        window.$common.fullLoading()
        await funEmployees.GetEmployeeMaintenanceStatistics(this.listQuery).then(response => {
          window.$common.closeFullLoading()
          this.tableData = response.map(x => {
            x.workAreas = []
            x.effective_rate = window.$util.toFixed(x.effectiveTasks / (x.totalTasks || 1) * 100)
            x.invalid_rate = window.$util.toFixed(x.invalidTasks / (x.totalTasks || 1) * 100)
            return x
          })
        })
        await this.getWorkAreasData()
      },
      async getWorkAreasData() {
        try {
          let tableData = [...this.tableData]
          // 使用串行请求，确保上一个请求完成后再执行下一个
          for (let index = 0; index < tableData.length; index++) {
            const item = tableData[index];
            let params = {
              telOrName: item.tel,
              beginDate: this.listQuery.beginDate,
              endDate: this.listQuery.endDate
            }
            // 等待当前请求完成后再执行下一个循环
            const response = await funEmployees.GetEmployeeMaintenanceTaskAreas(params);
            // 增加数据有效性检查
            if (Array.isArray(response)) {
              tableData[index].workAreas = response.map(x => x?.areaInfo) || [];
            } else {
              tableData[index].workAreas = [];
            }
          }
          this.tableData = [...tableData]
        } catch (error) {
          console.error('获取工作服务区数据失败:', error);
          this.errorMsg('获取工作服务区失败，请刷新重试');
        }
      },
      serviceAreaChange(val) {
        if (val === true) {
            this.listQuery.platform = this.$store.getters.servicePlatform || ""
            this.listQuery.area = this.$store.getters.serviceArea || ""
        } else {
            this.listQuery.platform = ""
            this.listQuery.area = ""
        }
        this._search()
      },
      tabClick(index) {
        this.tabIndex = index
        switch(index) {
          case 0: {
            let endTime = moment().subtract(1, "d").format("YYYY-MM-DD 23:59:59")
            this.selectedTime = [moment(endTime).format("YYYY-MM-DD 00:00:00"), endTime]
            break
          }
          case 1: {
            this.selectedTime = [moment().startOf("month").format("YYYY-MM-DD 00:00:00"), moment().format("YYYY-MM-DD 23:59:59")]
            break
          }
          case 2: {
            this.selectedTime = [moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD 00:00:00"), moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD 23:59:59")]
            break
          }
        }
        if (index !== 3) {
          this.isShowSelectTime = false
          this._search()
        } else {
          this.selectedTime = []
          this.isShowSelectTime = true
          this.tableData = []
        }
      },
      navTo(item, type) {
        // 默认只显示当前服务区的数据，isFilterArea为true代表查看全部数据
        // 所以去查看日志的时候是看指定员工的全部记录
        this.maintenanceDataTitle = `【${item.name} | ${item.tel}】的维修记录`
        this.maintenanceDataVisible = true
        setTimeout(() => {
          this.$refs[this.refMaintenanceData].open({
            isFilterArea: this.listQuery.isFilterArea,
            telOrName: item.tel, 
            selectedTime: this.selectedTime, 
            type, 
            tabIndex: this.tabIndex
          })
        }, 100)
        // this.$router.push({ 
        //   name: "pageEmployeeMaintenanceData", 
        //   params: { 
        //     isFilterArea: this.listQuery.isFilterArea,
        //     telOrName: item.name, 
        //     selectedTime: this.selectedTime, 
        //     type, 
        //     tabIndex: this.tabIndex
        //   } 
        // })
      },
      _search() {
        this.listQuery.page = 1
        this.getListData()
      },
      _close() {
        this.$refs[this.refMaintenanceData].close()
        this.maintenanceDataVisible = false
      },
      // 通过本地数据-导出员工维修统计数据
      openExportEmployeesExcelLocal() {
        if (this.total > this.maxExportCount) {
            this.warningMsg("不允许导出超过2万条数据，如有需要，请联系管理员处理!")
            return false
        } else if (this.total <= 0) {
            this.warningMsg("没有需要导出的数据!")
            return false
        }
        let tableDatas = this.tableData.map(x => {
          x.workAreaDesc = x.workAreas.map(y => {
            return `【${y.platform}】${y.name}`
          }).join(",")
          return x
        })
        let exportData = ""
        if (this.listQuery.beginDate && this.listQuery.endDate) {
          let sbtd = moment(this.listQuery.beginDate).format("YYYY-MM-DD")
          let ebtd = moment(this.listQuery.endDate).format("YYYY-MM-DD")
          exportData = sbtd == ebtd ? sbtd : `${sbtd}至${ebtd}`
        } else {
          exportData = "全部"
        }
        let exportName = `${this.listQuery.area || ""}员工维修统计(${exportData}).xlsx`
        AnalysisMaintenanceStatistics(exportName, tableDatas)
      },
      // 导出员工维修统计数据
      openExportEmployeesExcel() {
        if (this.total > this.maxExportCount) {
            this.warningMsg("不允许导出超过2万条数据，如有需要，请联系管理员处理!")
            return false
        }
        let searchs = JSON.parse(JSON.stringify(this.listQuery))
        searchs.page = 1
        searchs.size = this.maxExportCount
        window.$common.fullLoading()
        funEmployees.GetEmployeeMaintenanceStatistics(searchs).then(res => {
          if (res && res.length > 0) {
              let tableDatas = res.map(x => {
                x.effective_rate = window.$util.toFixed(x.effectiveTasks / (x.totalTasks || 1) * 100) + "%"
                x.invalid_rate = window.$util.toFixed(x.invalidTasks / (x.totalTasks || 1) * 100) + "%"
                return x
              })
              let exportData = ""
                if (searchs.beginDate && searchs.endDate) {
                  let sbtd = moment(searchs.beginDate).format("YYYY-MM-DD")
                  let ebtd = moment(searchs.endDate).format("YYYY-MM-DD")
                  exportData = sbtd == ebtd ? sbtd : `${sbtd}至${ebtd}`
                } else {
                  exportData = "全部"
                }
              let exportName = `${this.listQuery.area || ""}员工维修统计(${exportData}).xlsx`
              AnalysisMaintenanceStatistics(exportName, tableDatas)
          } else {
              window.$common.closeFullLoading()
              setTimeout(() => {
                  this.alert("没有需要导出的数据!")
              }, 10)
          }
        }).catch(() => {
            console.log("export error")
        })
      },
      openExportExcels() {
        try {
            window.$common.fullLoading()
            for (let i in this.tableData) {
                ((i) => {
                    setTimeout(() => {
                        this.openExportExcel(this.tableData[i])
                        if (i >= this.tableData.length - 1) {
                            window.$common.closeFullLoading()
                        }
                    }, (i + 1) * 50);
                })(i)
            }
        } catch(e) {
            this.alert("导出数据格式不正确!")
            return false
        }
      },
      openExportExcel(row) {
        if (this.total > this.maxExportCount) {
            this.warningMsg("不允许导出超过2万条数据，如有需要，请联系管理员处理!")
            return false
        }
        let searchs = JSON.parse(JSON.stringify(this.listQuery))
        searchs.page = 1
        searchs.size = this.maxExportCount
        if (row && row.name) {
          searchs.telOrName = row.name
        }
        window.$common.fullLoading()
        funEmployees.GetEmployeeMaintenanceTasks(searchs).then(res => {
            if (res && res.items && res.items.length > 0) {
                let tableDatas = res.items.map(x => {
                  x.created_at = this.getFormatDate(x.created_at)
                  x.fixed_time = this.getFormatDate(x.fixed_time)
                  return x
                })
                let exportData = ""
                if (searchs.beginDate && searchs.endDate) {
                  let sbtd = moment(searchs.beginDate).format("YYYY-MM-DD")
                  let ebtd = moment(searchs.endDate).format("YYYY-MM-DD")
                  exportData = sbtd == ebtd ? sbtd : `${sbtd}至${ebtd}`
                } else {
                  exportData = "全部"
                }
                let exportName = `${this.listQuery.area || ""}${row && row.name || '员工'}的维修数据(${exportData}).xlsx`
                AnalysisMaintenanceTask(exportName, tableDatas)
            } else {
                window.$common.closeFullLoading()
                setTimeout(() => {
                    this.alert("没有需要导出的数据!")
                }, 10)
            }
        }).catch((ex) => {
            console.log("export error: ", ex)
        })
      }
    }
  }
</script>